import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store';

@Module({
    namespaced: true,
    name: 'WarehouseSupport',
    store,
    dynamic: true,
})

class  WarehouseSupportCurrent extends  VuexModule {
    public support: {
        defaultCategory:number | null
    } =
        {
        defaultCategory:0
    }
    @Mutation
    public setDefaultCategory(id:number | null){
        this.support.defaultCategory = id
    }
    get DefaultCategory(){
        return this.support.defaultCategory
    }
}
export const WarehouseSupport =getModule(WarehouseSupportCurrent)